module.exports = __webpack_public_path__ + "static/img/fh_ty_icon.png";